import {Component, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {OKTA_AUTH, OktaAuthStateService} from '@okta/okta-angular';
import {OktaAuth} from '@okta/okta-auth-js';
import {environment} from '../../../environments/environment';


@Component({
  selector: 'app-navbar',
  standalone: false,

  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  signingOut = false;
  constructor(private router: Router,  @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
              public authState: OktaAuthStateService) {
  }

  async ngOnInit() {
    const user = await this.oktaAuth.getUser();
  }

  async logout(): Promise<void> {
    try {
      this.signingOut = true;
      await this.oktaAuth.signOut({
        postLogoutRedirectUri: environment.okta.postLogoutRedirectUri
      });
      // WICHTIG: kein router.navigate mehr – Okta macht den Redirect
    } finally {
      this.signingOut = false;
    }
  }
}
